import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from "./../../components/panel/panel.jsx";
import { UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import axios from "axios";
import { getOperators, saveOperator, deleteOperator } from "./../../services/operators";
import "bootstrap/dist/css/bootstrap.min.css";
import Pagination from "../../common/pagination";
import { paginate } from "../../utils/paginate";
import OperatorsTable from "../../components/operatorsTable.jsx";
import SearchBox from "./../../common/searchBox";
import _ from "lodash";
import http from "./../../services/httpService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Col, Button, Form, FormGroup, Input, Modal, Label, ModalHeader, ModalBody, Row } from "reactstrap";

import newIcon from "../../assets/Icons/new.svg";
import editIcon from "../../assets/Icons/edit.svg";
import trashIcon from "../../assets/Icons/trash.svg";
import csvIcon from "../../assets/Icons/csv.svg";
import xlsIcon from "../../assets/Icons/xls.svg";
import pdfIcon from "../../assets/Icons/pdf.svg";
import sharingIcon from "../../assets/Icons/sharing.svg";
import Icon from "./../../common/icon";

const apiUrl = process.env.REACT_APP_API_URL;

class OperatorsTableData extends Component {
	constructor(props) {
		super(props);
		this.state = {
			operators: [],
			pageSize: 10,
			currentPage: 1,
			sortColumn: { path: "operators.username", order: "asc" },
			searchQuery: "",
			checkedFields: [],
			errors: {},
		};
		this.handleDelete = this.handleDelete.bind(this);
		this.handleMassDelete = this.handleMassDelete.bind(this);
		this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
	}

	async componentDidMount() {
		document.title = "Operators";		
		const {data:operators} = await getOperators();
		this.setState({ operators });
	}

	handleDelete = async (operator) => {
		const operatorIdToDelete = operator._id;
		
		// Remove from UI immediately
		const operators = this.state.operators.filter((op) => op._id !== operatorIdToDelete);
		this.setState({ operators });
		
		try {
			await deleteOperator(operatorIdToDelete);
		} catch (ex) {
			if (ex.response && ex.response.status === 404) {
				alert("Operator already deleted or not found");
			} else {
				alert(`Failed to delete operator: ${ex.message || 'Unknown error'}`);
				// Reload data on error
				const { data: operators } = await getOperators();
				this.setState({ operators });
			}
		}
	};

	handleMassDelete = async (checkedFields) => {
		if (checkedFields.length === 0) {
			toast.warning("Please select items to delete.");
			return;
		}

		// Show confirmation dialog
		const confirmDelete = window.confirm(`Are you sure you want to delete ${checkedFields.length} operator record(s)?`);
		if (!confirmDelete) {
			return;
		}

		try {
			for (let i = 0; i < checkedFields.length; i++) {
				await deleteOperator(checkedFields[i]);
				const operators = this.state.operators.filter(
					(op) => op._id !== checkedFields[i]
				);
				this.setState({ operators });
			}
			
			// Clear checked fields after deletion
			this.setState({ checkedFields: [] });
			toast.success(`${checkedFields.length} operator record(s) deleted successfully!`);
		} catch (error) {
			console.error("Error deleting operator records:", error);
			if (error.response && error.response.status === 404) {
				toast.error("Some operators were already deleted.");
			} else {
				toast.error("Failed to delete operator records.");
			}
		}
	};

	handleCheckboxChange = ({ target: { checked, value } }) => {
		if (checked) {
			const checkedFields = [...this.state.checkedFields,value];
			this.setState({checkedFields});
		} else {
			const checkedFields = [...this.state.checkedFields];
			this.setState({ checkedFields:checkedFields.filter((e) => e !== value)});
		}
	};

	// Handle select all functionality
	handleSelectAll = (allIds) => {
		this.setState({ checkedFields: allIds });
	};

	handleSort = (sortColumn) => {
		this.setState({ sortColumn });
	};

	handlePageChange = (page) => {
		this.setState({ currentPage: page });
	};

	handleSearch = (query) => {
		this.setState({ searchQuery: query, currentPage: 1 });
	};

	getDataPgnation = () => {
		const { pageSize, currentPage, operators: Operators, sortColumn, searchQuery } = this.state;
		let filtered = Operators;
		if (searchQuery) {
			filtered = Operators.filter(
				(operator) => {
					// Access nested operator data
					const operatorData = operator.operators || {};
					const email = operatorData.email || '';
					const username = operatorData.username || '';
					const firstName = operatorData.contactName?.first || '';
					const lastName = operatorData.contactName?.last || '';
					const businessName = operator.companyInfo?.businessName || '';
					
					return email.toLowerCase().includes(searchQuery.toLowerCase()) ||
						   username.toLowerCase().includes(searchQuery.toLowerCase()) ||
						   firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
						   lastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
						   businessName.toLowerCase().includes(searchQuery.toLowerCase());
				}
			);
		}

		const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
		const operators = paginate(sorted, currentPage, pageSize);
		return { data: operators };
	};

	render() {
		const { length: count } = this.state.operators;
		const { pageSize, currentPage, sortColumn, searchQuery, checkedFields } = this.state;

		const { data: operators } = this.getDataPgnation();

		return (
			<div>
				<ol className="breadcrumb float-xl-right">
					<li className="breadcrumb-item">
						<Link to="user/operators">Operators</Link>
					</li>
					<li className="breadcrumb-item active">Data Tables</li>
				</ol>
				<h1 className="page-header">Operators </h1>
				<Panel>
					<PanelHeader>Operators Management</PanelHeader>

					<React.Fragment>
						<ToastContainer />
						<div className="toolbar" style={toolbarStyles}>
							<button className="btn btn-default active m-r-5 m-b-5" title="add operator" style={btnStyles}>
								{" "}
								<Link to="/user/operators/new">
									<img style={iconStyles} src={newIcon} />
								</Link>
							</button>

							<button
								className="btn btn-default m-r-5 m-b-5"
								title="Edit Operator"
								style={btnStyles}
								disabled={checkedFields.length !== 1}
							>
								<Link
									to={
										checkedFields.length === 1
											? `/user/operators/${checkedFields[0]}`
											: "#"
									}
								>
									<img style={iconStyles} src={editIcon} alt="Edit Icon" />
								</Link>
							</button>

							<button
								className="btn btn-default m-r-5 m-b-5"
								title="Delete Operator"
								style={btnStyles}
								disabled={checkedFields.length === 0}
								onClick={() =>
									this.handleMassDelete(checkedFields)
								}
							>
								<img style={iconStyles} src={trashIcon} alt="Delete Icon" />
							</button>
							<button className="btn btn-default active m-r-5 m-b-5" title="Excel" style={btnStyles}>
								{" "}
								<Link to="/user/operators/">
									<img style={iconStyles} src={xlsIcon} />
								</Link>{" "}
							</button>

							<button className="btn btn-default active m-r-5 m-b-5" title="csv" style={btnStyles}>
								{" "}
								<Link to="/user/operators/">
									<img style={iconStyles} src={csvIcon} />
								</Link>{" "}
							</button>
							<button className="btn btn-default active m-r-5 m-b-5" title="PDF" style={btnStyles}>
								{" "}
								<Link to="/user/operators/">
									<img style={iconStyles} src={pdfIcon} />
								</Link>{" "}
							</button>
							<button className="btn btn-default active m-r-5 m-b-5" title="Share to other" style={btnStyles}>
								{" "}
								<Link to="/user/operators/">
									<img style={iconStyles} src={sharingIcon} />
								</Link>{" "}
							</button>
						</div>
						<div className="table-responsive">
							<SearchBox value={searchQuery} onChange={this.handleSearch} />
							<p
								className="page-header float-xl-left"
								style={({ marginBottom: 5 }, { marginLeft: 20 }, { marginTop: 5 })}
							>
								{count} entries
							</p>

							<OperatorsTable
								operators={operators}
								onDelete={this.handleDelete}
								onSort={this.handleSort}
								sortColumn={sortColumn}
								handleCheckboxChange={this.handleCheckboxChange}
								onSelectAll={this.handleSelectAll}
								checkedFields={checkedFields || []}
							/>
						</div>
					</React.Fragment>

					<hr className="m-0" />
					<PanelBody>
						<div className="d-flex align-items-center justify-content-center">
							<Pagination
								itemsCount={count}
								pageSize={pageSize}
								onPageChange={this.handlePageChange}
								currentPage={currentPage}
							/>
						</div>
					</PanelBody>
				</Panel>
			</div>
		);
	}
}
const toolbarStyles = {
	background: "#c8e9f3",
	padding: "10px",
};

const btnStyles = { background: "#348fe2", margin: "0rem" };

const iconStyles = {
	width: "25px",
	height: "25px",
	marginRight: "0rem",
};

export default OperatorsTableData;
